import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "getInsuranceTypes";
export var useGetInsuranceTypes = function () {
    var dispatch = useDispatch();
    var loadingInsuranceTypes = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var insuranceTypes = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var errorInsuranceTypes = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var fetchInsuranceTypes = function (_a) {
        var enable = _a.enable, page = _a.page, limit = _a.limit, clientId = _a.clientId;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/ProjectType",
            queryParams: { enable: enable, page: page, limit: limit, clientId: clientId },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        fetchInsuranceTypes: fetchInsuranceTypes,
        insuranceTypes: insuranceTypes,
        loadingInsuranceTypes: loadingInsuranceTypes,
        errorInsuranceTypes: errorInsuranceTypes,
    };
};
